'use strict';
import * as $j_app$002edata$002e$002dLine$002dItem from "./app.data.-Line-Item.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps(items) {
  this.a8I = null;
  this.Yp = false;
  this.aif = false;
  this.Yq = false;
  this.a8I = items;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var res = false;
  var it = items.r();
  while (((!res) && it.l())) {
    res = $j_app$002edata$002e$002dLine$002dItem.$f_Lapp_data_LineItem__hasGrossWeight__Z(it.k());
  }
  this.Yp = res;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var res$1 = false;
  var it$1 = items.r();
  while (((!res$1) && it$1.l())) {
    res$1 = (!it$1.k().BG.c());
  }
  this.aif = res$1;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var res$2 = false;
  var it$2 = items.r();
  while (((!res$2) && it$2.l())) {
    res$2 = $j_app$002edata$002e$002dLine$002dItem.$f_Lapp_data_LineItem__hasNetWeight__Z(it$2.k());
  }
  this.Yq = res$2;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var res$3 = false;
  var it$3 = items.r();
  while (((!res$3) && it$3.l())) {
    res$3 = $j_app$002edata$002e$002dLine$002dItem.$f_Lapp_data_LineItem__hasAnyWeight__Z(it$3.k());
  }
}
export { $c_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps as $c_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps };
$p = $c_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps;
/** @constructor */
function $h_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps() {
}
export { $h_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps as $h_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps };
$h_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps)) {
    var x = this.a8I;
    var x$2 = x$0.a8I;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "LineItemProps";
});
$p.e = (function(n) {
  matchResult2: {
    var $x_1;
    if ((n === 0)) {
      var $x_1 = this.a8I;
      break matchResult2;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector($x_1);
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "items";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kx)));
}
export { $isArrayOf_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps as $isArrayOf_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps };
var $d_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps, "app.pages.view_document.ViewPurchaseOrder$LineItemProps", ({
  kx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps as $d_Lapp_pages_view\uff3fdocument_ViewPurchaseOrder$LineItemProps };
//# sourceMappingURL=app.pages.view_document.-View-Purchase-Order$-Line-Item-Props.js.map
